import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NetworkService } from '../../shared/network.service';
import * as io from 'socket.io-client';
import { CommonService } from '../../shared/common.service';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class TuftService {
  private pageChange = new BehaviorSubject('false');
  currentPage = this.pageChange.asObservable();
  observable: Observable<any>;
  socket;
  userDetail:any;
  
  constructor(
    private networkService: NetworkService,
    public commonService:CommonService
    ) {
      this.userDetail=  this.commonService.getUser();
    this.socket = io(environment.backendApiURL + '?userId=' + this.userDetail.userId);
     }
  updateColumnApi(body:any) {
    return this.networkService.put("tuftsapi/column/configurations",body, null,'bearer');
  } 
  getColumnList(query:any) {
    return this.networkService.get("tuftsapi/column/configurations?"+query,null, null,'bearer');
  }  

  submitChangeStatusApi(body:any) {
    return this.networkService.put("/tuftsapi/service/request/status",body, null,'bearer');
  }
  
   getCalendarReportListApi(query:any) {
    return this.networkService.get("tuftsapi/calendars/report?"+query,null, null,'bearer');
  } 
  onStudyTable(e) {
    this.socket.emit('joinOrLeaveStudyTableRoom', e);
  }
  studyToChat(e) {
    this.socket.emit('joinOrLeaveCircleRooms', e);
  }
  
}

